import useIsInStoryTellingContent from '@hooks/useIsInStoryTellingContent'
import translate from '@i18n'
import { desktopCSS, tabletCSS, mobileCSS } from '@measures/responsive'
import { FunctionComponent, ReactNode } from 'react'
import styled, { css } from 'styled-components'
import useIsInRecipeContent from '@hooks/useIsInRecipeContent'
import { printCSS } from '@utils/style'

interface AdBackgroundWrapperProps {
  slotCode?: string
  slotCodeMobile?: string
  children?: ReactNode
}

interface StyledAdBackgroundWrapperProps
  extends Pick<AdBackgroundWrapperProps, 'slotCode' | 'slotCodeMobile'> {
  shouldStretch: boolean
  isRecipe: boolean
}

const StyledAdBackgroundWrapper = styled.div<StyledAdBackgroundWrapperProps>`
  ${({
    shouldStretch,
    isRecipe,
    slotCode,
    slotCodeMobile,
    theme: {
      colors: {
        grey: { grey_10 },
      },
      measures: { stretch },
    },
  }) => css`
    padding-bottom: 16px;
    ${isRecipe &&
    css`
      margin: 24px 0;
    `}
    background: ${grey_10};
    width: auto;
    ${stretch('left', shouldStretch)}
    ${stretch('right', shouldStretch)}

    ${desktopCSS(css`
      ${!slotCode &&
      css`
        display: none;
      `}
    `)}

    ${tabletCSS(css`
      ${!slotCode &&
      css`
        display: none;
      `}
    `)}

    ${mobileCSS(css`
      ${!slotCodeMobile &&
      css`
        display: none;
      `}
    `)}
    ${printCSS(css`
      display: none;
    `)}
  `}
`

const AdTitle = styled.div`
  font-weight: normal;
  font-size: 12px;
  color: ${({ theme }) => theme.colors.grey.grey_70};
  text-transform: uppercase;
  letter-spacing: 2px;
  text-align: center;
  margin: 7px 0 6px;
`

const AdBackgroundWrapper: FunctionComponent<AdBackgroundWrapperProps> = ({
  slotCode,
  slotCodeMobile,
  children,
}) => {
  const isInStorytelling = useIsInStoryTellingContent()
  const isInRecipe = useIsInRecipeContent()
  const shouldStretch = isInStorytelling || isInRecipe

  return (
    <StyledAdBackgroundWrapper
      className="unblurred"
      shouldStretch={shouldStretch}
      isRecipe={isInRecipe}
      slotCode={slotCode}
      slotCodeMobile={slotCodeMobile}>
      <AdTitle>{translate('adsTitle')}</AdTitle>
      {children}
    </StyledAdBackgroundWrapper>
  )
}

export default AdBackgroundWrapper
